module.exports = __webpack_public_path__ + "img/imggheader.80ac12d9.svg";